import {BasicEntity} from "../../basic-entity-back/annotations";
import {Solicitud} from "./solicitud.model";
import {ManagerCachingStrategy} from "../../basic-entity-back/basic-entity-interface/mapping-external";

@BasicEntity({
    name: 'Diseño analógico',
    endpoint: 'solicitud_escaneos',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    acceptsBulkIriSearch: true,
    type: 'SolicitudEscaneo',
    managerCaching: ManagerCachingStrategy.Lazy,
    // Para el cliente: solo ve sus diseños, Responsable pide /empleados (403) y el Estado del panel es el que ve él
    // (`estadoCliente`), no el de la solicitud a secas
    sinFiltroEnElPanel: ['cliente', 'asignadoA', 'estado']
})

export class SolicitudEscaneo extends Solicitud {

}
